import Vue from 'vue'
import './cube-ui'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'

import '@/common/stylus/index.styl'

import VueLazyload from 'vue-lazyload'
let defaultImg = require("@/assets/icon.png");

Vue.use(VueLazyload, {
  loading: defaultImg
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
